const languageCategoryEnum = {
  ITALIAN: 'italian',
  POLISH: 'polish',
  SPANISH: 'spanish',
};

module.exports = { languageCategoryEnum };
